"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.setClipboardText = setClipboardText;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _copy = _interopRequireDefault(require("cccisd-icons/copy2"));
var _style = _interopRequireDefault(require("./style.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function setClipboardText(text) {
  // create a tiny invisible text area to programatically copy text
  var id = 'mycustom-clipboard-textarea-hidden-id';
  var existsTextarea = document.getElementById(id);
  if (!existsTextarea) {
    // if text area does not exist
    var textarea = document.createElement('textarea');
    textarea.id = id;
    textarea.style.position = 'fixed';
    textarea.style.top = 0;
    textarea.style.left = 0;
    textarea.style.width = '1px';
    textarea.style.height = '1px';
    textarea.style.padding = 0;
    textarea.style.border = 'none';
    textarea.style.outline = 'none';
    textarea.style.boxShadow = 'none';
    textarea.style.background = 'transparent';
    document.querySelector('body').appendChild(textarea);
    existsTextarea = document.getElementById(id);
  }
  existsTextarea.value = text;
  existsTextarea.select();
  document.execCommand('copy');
  (0, _cccisdNotification["default"])('Link copied!');
}
var Boilerplate = window.cccisd.boilerplate;
var UrlInfo = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function UrlInfo() {
    var _this;
    _classCallCheck(this, UrlInfo);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UrlInfo, [].concat(args));
    _defineProperty(_this, "getUrlText", function () {
      var _this$props$cycle = _this.props.cycle,
        hash = _this$props$cycle.hash,
        endpoint = _this$props$cycle.endpoint,
        _this$props$cycle$set = _this$props$cycle.settings,
        settings = _this$props$cycle$set === void 0 ? {} : _this$props$cycle$set;
      var useEndpoint = settings.useEndpoint;
      return Boilerplate.url(endpoint && useEndpoint ? "/survey/".concat(endpoint) : "/d/".concat(hash));
    });
    return _this;
  }
  _inherits(UrlInfo, _React$Component);
  return _createClass(UrlInfo, [{
    key: "render",
    value: function render() {
      var url = this.getUrlText();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].shaderbox
      }, /*#__PURE__*/_react["default"].createElement("h4", {
        className: _style["default"].label
      }, "Take this Quest at:", ' ', /*#__PURE__*/_react["default"].createElement("a", {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer"
      }, url)), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: (0, _classnames["default"])('btn', 'btn-info', _style["default"].copy),
        onClick: function onClick() {
          return setClipboardText(url);
        }
      }, "Copy ", /*#__PURE__*/_react["default"].createElement(_copy["default"], null)));
    }
  }]);
}(_react["default"].Component);
_defineProperty(UrlInfo, "propTypes", {
  cycle: _propTypes["default"].object
});